var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Headline hot-title"},[(_vm.headline)?_c('span',{staticClass:"hot-pic-num"},[_vm._v(_vm._s(_vm.headline))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"hot-title-txt"},[_vm._v(_vm._s(_vm.subhead))])])
}
var staticRenderFns = []

export { render, staticRenderFns }